import { render, staticRenderFns } from "./mpModule1.vue?vue&type=template&id=e4031a50&scoped=true"
import script from "./mpModule1.vue?vue&type=script&lang=js"
export * from "./mpModule1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4031a50",
  null
  
)

export default component.exports